<template>
    <div class="view-report-filter-panel sticky-filter-panel">
        <div class="view-report-filter-panel--content flex-grow-1 ms-4 pe-3">
            <!-- Filter Sections -->
            <div v-for="(dimension, index) in (local_page && local_page.dimensions) ? local_page.dimensions : []" :key="dimension.id" class="filter-section mb-3" v-show="!isTimePeriodFilter(dimension)">
                <div class="filter-section-header mb-2">
                    <h5 class="mb-0">{{ dimension.label }}</h5>
                </div>

                <!-- Multi-select Filter (Checkboxes) -->
                <div v-if="if_filter_options_loaded && (dimension.field_type === 'multi_select' || dimension.field_type === 'array_single_select' || dimension.field_type === 'array_multi_select')"
                    class="filter-options">
                    <div v-for="option in dimension.options" 
                        :key="option" 
                        class="filter-option-item"
                        @mouseover="setHover(option, true)" 
                        @mouseleave="setHover(option, false)">
                        <div class="form-check">
                            <input class="form-check-input" 
                                type="checkbox" 
                                :id="`filter-${dimension.id}-${option}`"
                                :value="option" 
                                v-model="dimension.value" 
                                @change="updateFilterState(index)" aria-label="Checkbox">
                            <label class="form-check-label w-100 d-flex justify-content-between align-items-center" 
                                :for="`filter-${dimension.id}-${option}`">
                                <span>
                                    {{ option }} 
                                    <!-- <span class="text-muted" v-if="benchmark_filters[dimension.id] && benchmark_filters[dimension.id].counts && benchmark_filters[dimension.id].counts[option] !== undefined">
                                        ({{ benchmark_filters[dimension.id].counts[option] }})
                                    </span> -->
                                    <i v-if="(dimension.column === 'org_vertical' && client?.vertical === option) || (dimension.column === 'org_annual_revenue' && client?.size === option)" 
                                    class="ms-1 fas fa-star text-warning"></i>
                                </span>
                                <button v-if="show_only_button[option] && benchmark_filters[dimension.id]" class="btn btn-sm btn-secondary" 
                                        @click.prevent.stop="toggleOnly(index, option)">
                                    ONLY
                                </button>
                            </label>
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div v-if="!if_filter_options_loaded" class="text-center py-3">
                        <div class="spinner-border spinner-border-sm me-2" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <span class="text-muted">Loading...</span>
                    </div>
                </div>

                <!-- Single-select Filter (Radio buttons) e.g. Period Type -->
                <div v-else-if="dimension.field_type === 'single_select' && getTimePeriodOptions(dimension).length > 0"
                    class="filter-options">
                    <div v-for="option in getTimePeriodOptions(dimension)"
                        :key="option"
                        class="filter-option-item">
                        <div class="form-check">
                            <input class="form-check-input"
                                type="radio"
                                :id="`filter-${dimension.id}-${option}`"
                                :value="option"
                                :name="`filter-${dimension.id}`"
                                v-model="dimension.value"
                                @change="updateFilterState(index)" aria-label="Radio option">
                            <label class="form-check-label" :for="`filter-${dimension.id}-${option}`">
                                {{ option }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer with Filter Count and Actions (sticky at bottom) -->
        <div class="sticky-bottom-container">
            <div class="sticky-bottom-content">
                <div class="d-flex flex-row justify-content-between align-items-center flex-nowrap gap-2">
                    <div class="d-flex flex-row justify-content-end align-items-center gap-2">
                        <span>{{ filter_count }} {{(filter_count > 1 ? 'Filters': 'Filter')}} {{filter_count_label}}</span>
                    </div>

                    <div class="d-flex flex-row justify-content-end align-items-center flex-nowrap gap-2">
                        <button type="button" class="btn btn-secondary" @click.prevent="clearFilters()" :disabled="if_refreshing">
                            Reset
                        </button>
                        <button v-if="!if_refreshing" type="button" class="btn btn-primary" @click.prevent="applyFilter()">
                            Apply
                        </button>
                        <button v-else type="button" class="btn btn-primary" disabled>
                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"><span class="visually-hidden"></span></div>
                            Loading
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { Tooltip, Dropdown } from 'bootstrap';

export default defineComponent({
    name: 'BenchmarkFilterPanel',
    components: {
        Swal
    },
    props: {
        page: {
            type: Object,
            default: null
        },
        benchmark_page: {
            type: Object,
            default: null
        },
        wiland_page: {
            type: Object,
            default: null
        },
        client: {
            type: Object,
            default: null
        },
        section_id: {
            type: [String, Number, null],
            default: null
        }
    },
    data() {
        return {
            local_page: {},
            benchmark_filters: {},
            filter_class: 'col-4',
            if_filter_options_loaded: false,
            if_filter_options_loading: false,
            if_refreshing: false,
            show_only_button: {},
            tooltips: [],
            dropdowns: [],
            filter_count: 0,
            filter_count_label: 'Applied',
        };
    },
    // computed: {
    //     filter_count() {
    //         let count = 0;
    //         if (this.local_page && this.local_page.dimensions) {
    //             this.local_page.dimensions.forEach(dim => {
    //                 if (dim.field_type === 'multi_select' && Array.isArray(dim.value)) {
    //                     if (dim.value.length > 0 && dim.value.length < dim.options?.length) {
    //                         count++;
    //                     }
    //                 } else if (dim.field_type === 'single_select' && dim.value) {
    //                     count++;
    //                 }
    //             });
    //         }
    //         return count;
    //     }
    // },
    beforeMount() {
        if (this.page) {
            this.local_page = JSON.parse(JSON.stringify(this.page));
            this.ensurePeriodTypeOptions();
        }
    },
    mounted() {
        // Only load filter options if page data is already available
        if (this.page && this.page.dimensions && this.page.dimensions.length > 0) {
            this.loadFilterOptions();
        }
        this.getFilterCount();
        this.$nextTick(() => {
            this.initializeTooltips();
            this.initializeDropdowns();
        });
    },
    watch: {
        page: {
            handler(newVal) {
                if (!newVal) return;
                
                const incomingPage = JSON.parse(JSON.stringify(this.page));
                if (this.if_filter_options_loaded && this.local_page && this.local_page.dimensions && incomingPage.dimensions) {
                    // Preserve loaded options when page updates (e.g. after chart refresh); API response often has no dimension.options
                    incomingPage.dimensions.forEach((incomingDim, idx) => {
                        const existing = this.local_page.dimensions.find(d => d.id === incomingDim.id);
                        if (existing && existing.options && existing.options.length > 0) {
                            incomingPage.dimensions[idx].options = existing.options;
                        }
                        // Keep incoming dimension value (applied filters)
                        if (incomingDim.value !== undefined) {
                            incomingPage.dimensions[idx].value = incomingDim.value;
                        }
                    });
                }
                this.local_page = incomingPage;
                this.ensurePeriodTypeOptions();
                
                // Load filter options when page data becomes available
                if (this.page && this.page.dimensions && this.page.dimensions.length > 0 && !this.if_filter_options_loaded) {
                    this.$nextTick(() => {
                        this.loadFilterOptions();
                    });
                } else if (this.if_filter_options_loaded) {
                    // Options already loaded, just update filter count and force update to re-render with new values
                    this.$nextTick(() => {
                        this.getFilterCount();
                        this.$forceUpdate();
                    });
                } else {
                    // Update filter count when dimensions change (e.g., persisted filters loaded)
                    this.$nextTick(() => {
                        this.getFilterCount();
                    });
                }
            },
            deep: true,
            immediate: true
        },
        local_page: {
            handler() {
                this.getFilterCount();
            },
            deep: true
        }
    },
    methods: {
        initializeDropdowns() {
            // Destroy existing dropdowns first
            this.dropdowns.forEach(dropdown => dropdown.dispose());
            this.dropdowns = [];

            // Initialize new dropdowns
            const dropdownElements = document.querySelectorAll('.dropdown-toggle');
            dropdownElements.forEach(element => {
                const dropdown = new Dropdown(element, {
                    autoClose: element.dataset.bsAutoClose === 'true' ? true : 'outside'
                });
                this.dropdowns.push(dropdown);
            });
        },
        initializeTooltips() {
            // Destroy existing tooltips first
            this.tooltips.forEach(tooltip => tooltip.dispose());
            this.tooltips = [];

            // Initialize new tooltips
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach(element => {
                const tooltip = new Tooltip(element, {
                    trigger: 'hover',
                    html: true
                });
                this.tooltips.push(tooltip);
            });
        },
        loadFilterOptions() {
            // Ensure page data and dimensions exist before making API call
            if (!this.local_page || !this.local_page.dimensions || this.local_page.dimensions.length === 0) {
                return;
            }

            // Prevent duplicate or concurrent calls
            if (this.if_filter_options_loaded || this.if_filter_options_loading) {
                return;
            }

            this.if_filter_options_loading = true;

            // Use benchmark page for the API when available (benchmark_constituent table); wiland page (benchmark_wiland) can cause the filters API to fail
            const pageForApi = (this.benchmark_page && this.benchmark_page.data_blend)
                ? { ...JSON.parse(JSON.stringify(this.benchmark_page)), dimensions: this.local_page.dimensions }
                : this.local_page;

            // Create a deep copy of the page and clear chart data (matching ReportViewFilterPanel pattern)
            const data = {
                page: JSON.parse(JSON.stringify(pageForApi)),
                filters: this.local_page.dimensions,
            };

            // Loop through data.page.sections.charts.chart and set data to NULL
            if (data.page && data.page.sections && Array.isArray(data.page.sections)) {
                data.page.sections.forEach(section => {
                    if (section.charts && Array.isArray(section.charts)) {
                        section.charts.forEach(chart => {
                            if (chart && chart.chart) {
                                chart.chart.data = null;
                            }
                        });
                    }
                });
            }

            window.axios.post('/api/benchmarks/filters', data)
                .then(response => {
                    this.if_filter_options_loading = false;
                    this.if_filter_options_loaded = true;

                    response.data.filters.forEach(filter => {
                        this.benchmark_filters[filter.id] = filter;
                    });

                    for (let i = 0; i < this.local_page.dimensions.length; i++) {
                        for (let j = 0; j < response.data.filters.length; j++) {
                            if (this.local_page.dimensions[i].id === response.data.filters[j].id) {
                                this.local_page.dimensions[i].options = response.data.filters[j].options;
                                response.data.filters[j].options.forEach(option => {
                                    this.show_only_button[option] = false;
                                });
                                this.local_page.dimensions[i].disabled = false;
                            }
                        }
                    }
                    this.loadInitialFilterStatus();
                    this.getFilterCount();
                    this.$nextTick(() => {
                        this.initializeDropdowns();
                    });
                })
                .catch(() => {
                    this.if_filter_options_loading = false;
                });
        },
        setHover(item, flag) {
            this.show_only_button[item] = flag;
            this.$forceUpdate();
        },
        ensurePeriodTypeOptions() {
            if (!this.local_page || !this.local_page.dimensions) return;
            const periodDim = this.local_page.dimensions.find(d => d.column === 'period_type');
            if (periodDim && (!periodDim.options || periodDim.options.length === 0)) {
                periodDim.options = ['Calendar Year', 'Trailing 12 Months'];
            }
        },
        getTimePeriodOptions(dimension) {
            if (!dimension) return [];
            if (dimension.column === 'period_type') {
                return dimension.options && dimension.options.length > 0
                    ? dimension.options
                    : ['Calendar Year', 'Trailing 12 Months'];
            }
            return dimension.options && Array.isArray(dimension.options) ? dimension.options : [];
        },
        /** True when dimension is single_select with exactly two options (e.g. Period Type); such filters are hidden from panel and from applied count. */
        isTimePeriodFilter(dimension) {
            if (!dimension || dimension.field_type !== 'single_select') return false;
            const opts = this.getTimePeriodOptions(dimension);
            return opts.length === 2;
        },
        updateFilterState(index) {
            // Only update local state, don't trigger API call
            if (!this.local_page || !this.local_page.dimensions || !this.local_page.dimensions[index]) {
                return;
            }
            
            const dimension = this.local_page.dimensions[index];
            const filter = this.benchmark_filters[dimension.id];
            
            if (dimension.field_type === 'single_select') {
                this.filter_count_label = 'Selected';
                this.getFilterCount();
                this.$forceUpdate();
                return;
            }
            if (!filter) {
                return;
            }
            this.filter_count_label = 'Selected';
            this.getFilterCount();
            this.$forceUpdate();
        },
        sortRevenueRangeOptions() {
            if (!this.local_page || !this.local_page.dimensions) {
                return;
            }
            
            const revenue_range = ["Less than $1M", "$1M-$5M", "$5M-$10M", "$10M-$25M", "$25M-$50M", "$50M+"];
            const index = this.local_page.dimensions.findIndex(dimension => dimension.column === "org_annual_revenue");
            if (index >= 0 && this.local_page.dimensions[index] && Array.isArray(this.local_page.dimensions[index].options)) {
                this.local_page.dimensions[index].options.sort((a, b) => revenue_range.indexOf(a) > revenue_range.indexOf(b) ? 1 : -1);
            }
        },
        loadInitialFilterStatus() {
            if (!this.local_page || !this.local_page.dimensions) {
                return;
            }
            
            this.sortRevenueRangeOptions();

            const hasValue = (dim) => {
                const v = dim.value;
                if (Array.isArray(v)) return v.length > 0;
                return v !== undefined && v !== null && v !== '';
            };

            const vertical_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "org_vertical");
            if (vertical_index >= 0 && this.local_page.dimensions[vertical_index]) {
                const verticalDimension = this.local_page.dimensions[vertical_index];
                if (verticalDimension.options && !hasValue(verticalDimension)) {
                    verticalDimension.value = verticalDimension.options;
                }
            }

            const annual_revenue_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "org_annual_revenue");
            if (annual_revenue_index >= 0 && this.local_page.dimensions[annual_revenue_index]) {
                const revenueDimension = this.local_page.dimensions[annual_revenue_index];
                if (revenueDimension.options && !hasValue(revenueDimension)) {
                    revenueDimension.value = revenueDimension.options;
                }
            }

            if (this.local_page.name !== 'Year End Benchmark') {
                const period_type_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "period_type");
                if (period_type_index >= 0 && this.local_page.dimensions[period_type_index]) {
                    const periodDim = this.local_page.dimensions[period_type_index];
                    if (!periodDim.options || periodDim.options.length === 0) {
                        periodDim.options = ['Calendar Year', 'Trailing 12 Months'];
                    }
                    if (!hasValue(periodDim)) {
                        periodDim.value = "Trailing 12 Months";
                    }
                }
            }
            
            if (this.local_page.dimensions.length >= 3) {
                this.filter_class = "col-3";
            }

            // this.if_vertical_filter_applied = false;
            // this.if_revenue_filter_applied = false;

            this.$forceUpdate();
        },
        toggleOnly(index = null, option = null) {
            if (!this.local_page || !this.local_page.dimensions || !this.local_page.dimensions[index]) {
                return;
            }
            
            const dimension = this.local_page.dimensions[index];
            dimension.value = [option];
            this.$forceUpdate();
        },
        applyFilter() {
            var self = this;
            this.if_refreshing = true;
            this.$emit('refreshing', this.if_refreshing);

            // Check if we need to apply filters to both pages
            const applyToBothPages = this.benchmark_page && this.wiland_page;

            // Make a copy of the page with filters applied
            var page_copy = JSON.parse(JSON.stringify(this.local_page));
            // Loop through the sections and charts and set the data to null
            if (page_copy.sections && Array.isArray(page_copy.sections)) {
                page_copy.sections.forEach(section => {
                    if (section.charts && Array.isArray(section.charts)) {
                        section.charts.forEach(chart => {
                            if (chart.chart) {
                                chart.chart.data = null;
                            }
                        });
                    }
                });
            }

            if (applyToBothPages) {
                // Apply filters to both pages
                const benchmarkPageCopy = JSON.parse(JSON.stringify(this.benchmark_page));
                benchmarkPageCopy.dimensions = page_copy.dimensions;
                
                // Clear chart data for benchmark page
                if (benchmarkPageCopy.sections && Array.isArray(benchmarkPageCopy.sections)) {
                    benchmarkPageCopy.sections.forEach(section => {
                        if (section.charts && Array.isArray(section.charts)) {
                            section.charts.forEach(chart => {
                                if (chart.chart) {
                                    chart.chart.data = null;
                                }
                            });
                        }
                    });
                }

                const wilandPageCopy = JSON.parse(JSON.stringify(this.wiland_page));
                wilandPageCopy.dimensions = page_copy.dimensions;
                
                // Clear chart data for wiland page
                if (wilandPageCopy.sections && Array.isArray(wilandPageCopy.sections)) {
                    wilandPageCopy.sections.forEach(section => {
                        if (section.charts && Array.isArray(section.charts)) {
                            section.charts.forEach(chart => {
                                if (chart.chart) {
                                    chart.chart.data = null;
                                }
                            });
                        }
                    });
                }

                // Make API calls to both pages in parallel
                Promise.all([
                    window.axios.post('/api/insights/page/' + this.benchmark_page.id, benchmarkPageCopy),
                    window.axios.post('/api/insights/page/' + this.wiland_page.id, wilandPageCopy)
                ])
                    .then(([benchmarkResponse, wilandResponse]) => {
                        // Verify filters were applied correctly
                        let if_lastest_filter = true;
                        this.local_page.dimensions.forEach((udf, udf_index) => {
                            if (!benchmarkResponse.data.page.dimensions || 
                                !benchmarkResponse.data.page.dimensions[udf_index] ||
                                JSON.stringify(udf.value) != JSON.stringify(benchmarkResponse.data.page.dimensions[udf_index].value)) {
                                if_lastest_filter = false;
                            }
                        });
                        
                        // Always clear loading state
                        this.if_refreshing = false;
                        this.$emit('refreshing', this.if_refreshing);
                        
                        if (if_lastest_filter) {
                            const page_temp = this.local_page;
                            this.local_page = benchmarkResponse.data.page;
                            this.local_page.dimensions = page_temp.dimensions;
                            this.local_page.id = page_temp.id;
                            this.local_page.crm_status = page_temp.crm_status;

                            this.filter_count_label = 'Applied';
                            this.getFilterCount();
                            this.saveFiltersToStorage();
                            this.$emit('updatePage', {
                                benchmark_page: benchmarkResponse.data.page,
                                wiland_page: wilandResponse.data.page,
                                dimensions: this.local_page.dimensions
                            });
                            this.$emit('closePanel');
                        } else {
                            // Filters don't match, but still update the page with the response
                            const page_temp = this.local_page;
                            this.local_page = benchmarkResponse.data.page;
                            this.local_page.dimensions = page_temp.dimensions;
                            this.local_page.id = page_temp.id;
                            this.local_page.crm_status = page_temp.crm_status;

                            this.filter_count_label = 'Applied';
                            this.getFilterCount();
                            this.saveFiltersToStorage();
                            this.$emit('updatePage', {
                                benchmark_page: benchmarkResponse.data.page,
                                wiland_page: wilandResponse.data.page,
                                dimensions: this.local_page.dimensions
                            });
                            this.$emit('closePanel');
                        }
                    })
                    .catch(error => {
                        console.error('Error applying filters:', error);
                        this.if_refreshing = false;
                        this.$emit('refreshing', this.if_refreshing);
                        
                        Swal.fire({
                            title: 'Error',
                            text: 'Something went wrong when trying to apply the filters. Please refresh the page and try again.',
                            icon: 'error',
                            confirmButtonText: "Refresh",
                            customClass: {
                                popup: 'swal-error'
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });
                    });
            } else {
                // Single page update (original logic for backward compatibility)
                window.axios.post('/api/insights/page/' + this.page.id, page_copy)
                    .then(response => {
                        let if_lastest_filter = true;
                        this.local_page.dimensions.forEach((udf, udf_index) => {
                            if (!response.data.page.dimensions || 
                                !response.data.page.dimensions[udf_index] ||
                                JSON.stringify(udf.value) != JSON.stringify(response.data.page.dimensions[udf_index].value)) {
                                if_lastest_filter = false;
                            }
                        });
                        
                        // Always clear loading state
                        this.if_refreshing = false;
                        this.$emit('refreshing', this.if_refreshing);
                        
                        if (if_lastest_filter) {
                            const page_temp = this.local_page;
                            this.local_page = response.data.page;
                            this.local_page.dimensions = page_temp.dimensions;
                            this.local_page.id = page_temp.id;
                            this.local_page.crm_status = page_temp.crm_status;

                            this.filter_count_label = 'Applied';
                            this.getFilterCount();
                            this.saveFiltersToStorage();
                            this.$emit('updatePage', this.local_page);
                            this.$emit('closePanel');
                        } else {
                            // Filters don't match, but still update the page with the response
                            const page_temp = this.local_page;
                            this.local_page = response.data.page;
                            this.local_page.dimensions = page_temp.dimensions;
                            this.local_page.id = page_temp.id;
                            this.local_page.crm_status = page_temp.crm_status;

                            this.filter_count_label = 'Applied';
                            this.getFilterCount();
                            this.saveFiltersToStorage();
                            this.$emit('updatePage', this.local_page);
                            this.$emit('closePanel');
                        }
                    })
                    .catch(error => {
                        console.error('Error applying filters:', error);
                        this.if_refreshing = false;
                        this.$emit('refreshing', this.if_refreshing);
                        
                        Swal.fire({
                            title: 'Error',
                            text: 'Something went wrong when trying to apply the filters. Please refresh the page and try again.',
                            icon: 'error',
                            confirmButtonText: "Refresh",
                            customClass: {
                                popup: 'swal-error'
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                location.reload();
                            }
                        });
                    });
            }
        },
        clearFilters() {
            this.setDefaultFilterValues();
            this.filter_count_label = 'Selected';
            this.getFilterCount();
            this.$forceUpdate();
        },
        setDefaultFilterValues() {
            if (!this.local_page || !this.local_page.dimensions) {
                return;
            }
            
            this.sortRevenueRangeOptions();

            const hasValue = (dim) => {
                const v = dim.value;
                if (Array.isArray(v)) return v.length > 0;
                return v !== undefined && v !== null && v !== '';
            };

            const vertical_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "org_vertical");
            if (vertical_index >= 0 && this.local_page.dimensions[vertical_index]) {
                const verticalDimension = this.local_page.dimensions[vertical_index];
                if (verticalDimension.options) {
                    verticalDimension.value = verticalDimension.options;
                }
            }

            const annual_revenue_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "org_annual_revenue");
            if (annual_revenue_index >= 0 && this.local_page.dimensions[annual_revenue_index]) {
                const revenueDimension = this.local_page.dimensions[annual_revenue_index];
                if (revenueDimension.options) {
                    revenueDimension.value = revenueDimension.options;
                }
            }

            if (this.local_page.name !== 'Year End Benchmark') {
                const period_type_index = this.local_page.dimensions.findIndex(dimension => dimension.column === "period_type");
                if (period_type_index >= 0 && this.local_page.dimensions[period_type_index]) {
                    const periodDim = this.local_page.dimensions[period_type_index];
                    if (!periodDim.options || periodDim.options.length === 0) {
                        periodDim.options = ['Calendar Year', 'Trailing 12 Months'];
                    }
                    periodDim.value = "Trailing 12 Months";
                }
            }
        },
        saveFiltersToStorage() {
            if (!this.local_page || !this.local_page.dimensions) {
                return;
            }
            
            const filterState = {};
            this.local_page.dimensions.forEach(dim => {
                if (dim.value !== null && dim.value !== undefined) {
                    filterState[dim.column] = dim.value;
                }
            });
            
            const clientKey = this.client ? this.client.url : 'demo';
            const storageKey = `wiland_benchmark_filters_${clientKey}`;
            
            try {
                localStorage.setItem(storageKey, JSON.stringify(filterState));
            } catch (e) {
                console.error('Failed to save filters to localStorage:', e);
            }
        },
        getFilterCount() {
            let filter_count_temp = 0;
            
            if (!this.local_page || !this.local_page.dimensions) {
                this.filter_count = filter_count_temp;
                return filter_count_temp;
            }

            this.local_page.dimensions.forEach((dimension) => {
                if (!dimension) return;

                // Check if filter has a value that differs from default/empty state
                if (dimension.field_type === 'date_range' || dimension.field_type === 'month_range') {
                    if (dimension.value && (dimension.value.start_date || dimension.value.end_date)) {
                        filter_count_temp++;
                    }
                } else if (dimension.field_type === 'single_select') {
                    if (this.isTimePeriodFilter(dimension)) {
                        // Hide single-select-with-two-options from count (e.g. Period Type)
                    } else if (dimension.value && dimension.value !== '') {
                        filter_count_temp++;
                    }
                } else if (dimension.field_type === 'multi_select' || dimension.field_type === 'month_picker') {
                    if (dimension.value && Array.isArray(dimension.value) && dimension.value.length > 0) {
                        // For benchmark filters (org_vertical, org_annual_revenue), only count if not all options selected
                        if (['org_vertical', 'org_annual_revenue'].includes(dimension.column)) {
                            if (dimension.options && dimension.value.length < dimension.options.length) {
                                filter_count_temp++;
                            }
                        } else {
                            filter_count_temp++;
                        }
                    }
                } else if (dimension.field_type === 'numeric_slider') {
                    if (dimension.value !== null) {
                        filter_count_temp++;
                    }
                }
            });

            this.filter_count = filter_count_temp;
            return filter_count_temp;
        }
    }
});
</script>